/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, {useState, useCallback, useRef, useEffect} from 'react'
import moment from 'moment';
import Checkbox from 'react-custom-checkbox';
import * as Icon from 'react-icons/fi';
import { Calendar } from 'react-calendar';
import { createUrl } from '../../../redux/helper/CreateQuery';

const FilterModal = ({filterModal,setFilterModal, Filter, setFilter, selected, SetSuccessMessage,
    setselected,
    handleFilter,
    filterValue,
    setfilterValue,
    handleInvoiceReport,
    threeplList,
    setThreeplList,
    InvoiceReportList,}) => {
    const dateRef = useRef();
    const dateRef1 = useRef();
    const [selectedType, setselectedType] = useState('order_category');
    const toggleState = {
        invoice_start_date: false,
        invoice_end_date: false,
        order_start_date: false,
        order_end_date: false,
    };
    const [toggle, settoggle] = useState(toggleState);

    const HandleFilter = useCallback((key, val) => {
        const Filtercopy = { ...Filter };
        const idx = Filtercopy[key].indexOf(val);
        if (idx === -1) {
            Filtercopy[key].push(val);
        } else {
            Filtercopy[key].splice(idx, 1);
        }
        Filtercopy[key];
        setFilter(Filtercopy);
        return idx > -1;
        // return false
    }, []);

    const handleToggle = (key) => {
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
        }));
    };

    const handleDate = (val, key) => {
        const state = key === 'invoice_start_date' ? 'invoice_end_date' : 'invoice_start_date';
        if (key === 'invoice_start_date') {
            setselected((prevState) => ({
                ...prevState,
                end_date: '',
            }));
        }
        settoggle(toggleState);
        if (key === 'invoice_end_date') {
            settoggle(toggleState);
        } else {
            setTimeout(() => {
                handleToggle(state);
            }, 500);
        }
        setselected((prevState) => ({
            ...prevState,
            [key]: val,
        }));
        if (key === 'invoice_end_date') {
            settoggle(toggleState);
        }
    };

    const generateUrl = (val) => {
        let final = '';
        Object.keys(Filter).map((key) => {
            switch (key) {
            case 'order_category':
                if (Filter[key].length > 0) {
                    final += `&order_category=${createUrl(Filter[key])}`;
                }
                break;
            case 'payment_status':
                if (Filter[key].length > 0) {
                    final += `&payment_status=${createUrl(Filter[key])}`;
                }
                break;
            default: break;
            }
        });
        if (selected.invoice_start_date !== '' && selected.invoice_end_date !== '') {
            final += `&TRX_DATE=${moment(selected.invoice_start_date).format('DD-MM-YYYY')},${moment(selected.invoice_end_date).format('DD-MM-YYYY')}`;
        }
        if (selected.order_start_date !== '' && selected.order_end_date !== '') {
            final += `&ORDER_DATE=${moment(selected.order_start_date).format('DD-MM-YYYY')},${moment(selected.order_end_date).format('DD-MM-YYYY')}`;
        }
        if (val === undefined) {
            handleFilter(final);
        }
        setFilterModal(false);
        SetSuccessMessage('Filter(s) applied');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 1000);
        return final;
    };

    const handleClear = () => {
        setFilter({
            order_category: [],
            payment_status: [],          
        });
        setselected({  order_start_date: '',
            order_end_date: '',
            invoice_start_date: '',
            invoice_end_date: '', });
        setfilterValue('');
        handleInvoiceReport();
        setFilterModal(false);
        SetSuccessMessage('Filter(s) cleared');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 1000);  
    };
  
    useEffect(() => {
        const handler = (event) => {
            if (dateRef && !dateRef.current.contains(event.target)) {
                settoggle((prevState) => ({
                    ...prevState,
                    invoice_start_date: false,
                    invoice_end_date: false,               
                }));
                // setNotificationDropdown(false)
                // setReportsDropdown(false)
            }
        };
        document.addEventListener('mousedown', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, [dateRef]);

    useEffect(() => {
        const handler = (event) => {
            if (dateRef1 && !dateRef1.current.contains(event.target)) {
                settoggle((prevState) => ({
                    ...prevState,
                    order_start_date: false,
                    order_end_date: false,                  
                }));
                // setNotificationDropdown(false)
                // setReportsDropdown(false)
            }
        };
        document.addEventListener('mousedown', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, [dateRef1]);

    return (
        <div className={`modal fade ${filterModal ? 'show' : 'hidden'} fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="filtermodal" tabIndex="-1" aria-labelledby="deactivateOfferModal" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:max-w-[470px] mx-auto px-2.5" style={{margin:'auto'}}>
                <div
                    className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                        <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                            Filter
                        </h5>
                        <button type="button"
                            className="absolute top-4 right-6"                             
                            data-bs-dismiss="modal" 
                            aria-label="Close"
                            onClick={() => setFilterModal(false)}
                        >
                            <img src="/images/close.svg" alt="icon" className="w-3.5 h-3.5"/>
                        </button>
                    </div>
                    <div className="modal-body relative sm:px-5 px-3 sm:pt-5 pt-4 sm:pb-7 pb-5 text-center">
                        <div className="flex items-start">
                            <ul className="nav nav-pills flex flex-col flex-wrap items-start list-none pl-0 w-[30%] h-full" id="pills-tabVertical" role="tablist">
                                <li className="nav-item flex-grow w-full text-start" role="presentation" onClick={() => setselectedType('order_category')}>
                                    <a href="javascript:void(0)" className={`nav-link block text-base font-semibold text-[#AAA6AF] order ${selectedType === 'order_category' ? 'active' : ''} relative w-full`} id="pills-priceranje" data-bs-toggle="pill" data-bs-target="#pills-pricetab" role="tab"
                                        aria-controls="pills-price" aria-selected="true">Order Category
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start w-full my-4" role="presentation" onClick={() => setselectedType('payment_status')}>
                                    <a href="javascript:void(0)" className={`nav-link block text-base font-semibold text-[#AAA6AF] order ${selectedType === 'payment_status' ? 'active' : ''} relative w-full`} id="pills-size" data-bs-toggle="pill" data-bs-target="#pills-sizemm" role="tab"
                                        aria-controls="pills-sizemm" aria-selected="false" >Payment Status
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start w-full mb-4" role="presentation" onClick={() => setselectedType('invoice_date')}>
                                    <a href="javascript:void(0)" className={`nav-link block text-base font-semibold text-[#AAA6AF] order ${selectedType === 'invoice_date' ? 'active' : ''} relative w-full`} id="pills-categories" data-bs-toggle="pill" data-bs-target="#pillcategorie" role="tab"
                                        aria-controls="pillcategorie" aria-selected="false">Invoice Date
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start w-full" role="presentation" onClick={() => setselectedType('order_date')}>
                                    <a href="javascript:void(0)" className={`nav-link block text-base font-semibold text-[#AAA6AF] order ${selectedType === 'order_date' ? 'active' : ''} relative w-full`} id="pills-type" data-bs-toggle="pill" data-bs-target="#pilltype" role="tab"
                                        aria-controls="pillcategorie" aria-selected="false">Order Date
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content w-[70%] h-[192px] border-l border-[#D8D8D8]" id="pills-tabContentVertical">
                                <div className={`tab-pane ${selectedType === 'order_category' ? 'show active' : 'hidden'} fade px-3`} id="pills-pricetab" role="tabpanel" aria-labelledby="pills-priceranje">
                                    <div className="relative">
                                        <div className="cursor-pointer">
                                            <div className="flex items-center mb-3">
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_category?.includes('CONSUMABLES') ? '#555259' : ''}` }} />
                                                    }
                                                    name="my-input"
                                                    className="cursor-pointer"
                                                    checked={Filter.order_category.includes('CONSUMABLES')}
                                                    onChange={() => HandleFilter('order_category', 'CONSUMABLES')}
                                                    borderColor={`${Filter.order_category.includes('CONSUMABLES') ? '#B8C5DC' : '#555259'}`}
                                                    style={{ cursor: 'pointer' }}
                                                    labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                />
                                                <label htmlFor="mn1" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Consumables</label>
                                            </div>
                                            <div className="flex items-center mb-3">
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_category?.includes('EQUIPMENTS') ? '#555259' : ''}` }} />
                                                    }
                                                    name="my-input"
                                                    className="cursor-pointer"
                                                    checked={Filter.order_category.includes('EQUIPMENTS')}
                                                    onChange={() => HandleFilter('order_category', 'EQUIPMENTS')}
                                                    borderColor={`${Filter.order_category.includes('EQUIPMENTS') ? '#B8C5DC' : '#555259'}`}
                                                    style={{ cursor: 'pointer' }}
                                                    labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                />
                                                <label htmlFor="mn2" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Equipments</label>
                                            </div>
                                            <div className="flex items-center mb-3">
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_category?.includes('OTHERS') ? '#555259' : ''}` }} />
                                                    }
                                                    name="my-input"
                                                    className="cursor-pointer"
                                                    checked={Filter.order_category.includes('OTHERS')}
                                                    onChange={() => HandleFilter('order_category', 'OTHERS')}
                                                    borderColor={`${Filter.order_category.includes('OTHERS') ? '#B8C5DC' : '#555259'}`}
                                                    style={{ cursor: 'pointer' }}
                                                    labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                />
                                                <label htmlFor="an1" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Others</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`tab-pane ${selectedType === 'payment_status' ? 'show active' : 'hidden'} fade w-full`} id="pills-sizemm" role="tabpanel" aria-labelledby="pills-size">
                                    <div className="ml-5 cursor-pointer">
                                        <div className="flex items-center">
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.payment_status?.includes('PENDING') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.payment_status.includes('PENDING')}
                                                onChange={() => HandleFilter('payment_status', 'PENDING')}
                                                borderColor={`${Filter.payment_status.includes('PENDING') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                            />
                                            <label htmlFor="mn3" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Pending</label>
                                        </div>
                                        <div className="flex items-center mt-[14px]">
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.payment_status?.includes('PARTIAL') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.payment_status.includes('PARTIAL')}
                                                onChange={() => HandleFilter('payment_status', 'PARTIAL')}
                                                borderColor={`${Filter.payment_status.includes('PARTIAL') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                            />
                                            <label htmlFor="mn4" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Partial</label>
                                        </div>
                                        <div className="flex items-center mt-[14px]">
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.payment_status?.includes('PAID') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.payment_status.includes('PAID')}
                                                onChange={() => HandleFilter('payment_status', 'PAID')}
                                                borderColor={`${Filter.payment_status.includes('PAID') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                            />
                                            <label htmlFor="mn5" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Paid</label>
                                        </div>
                                    </div>
                                </div>
                                <div className={`tab-pane ${selectedType === 'invoice_date' ? 'show active' : 'hidden'} fade px-3`} id="pillcategorie" role="tabpanel" aria-labelledby="pills-categories">
                                    <div ref={dateRef} className="relative">
                                        <div className="flex sm:flex-row flex-col items-center mt-1 -mx-1">
                                            <div 
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('invoice_start_date')}
                                            >
                                                <label></label>
                                                <img 
                                                    src="/images/Iconawesome-calendar-alt.svg" 
                                                    alt="icon" 
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('invoice_start_date')}
                                                />
                                                <input 
                                                    datepicker 
                                                    datepicker-autohide 
                                                    type="text" 
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] sm:text-xs9 text-sm29 font-semibold text-[#090406] px-2.5 placeholder:text-xs9 placeholder:font-normal placeholder:text-[#808285]" 
                                                    placeholder="From date"
                                                    value={selected.invoice_start_date === '' ? '' : moment(selected.invoice_start_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.invoice_start_date && <Calendar 
                                                value={moment(selected.invoice_start_date).format('YYYY/MM/DD').invoice_start_date} 
                                                onChange={(val) => handleDate(val, 'invoice_start_date')} 
                                                placeholder="Date from" 
                                            />}
                                            <div 
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('invoice_end_date')}
                                            >
                                                <label></label>
                                                <img 
                                                    src="/images/Iconawesome-calendar-alt.svg" 
                                                    alt="icon" 
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('invoice_end_date')}
                                                />
                                                <input 
                                                    datepicker 
                                                    datepicker-autohide 
                                                    type="text" 
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] sm:text-xs9 text-sm29 font-semibold text-[#090406] px-2.5 placeholder:text-xs9 placeholder:font-normal placeholder:text-[#808285]"  
                                                    placeholder="To date"
                                                    value={selected.invoice_end_date === '' ? '' : moment(selected.invoice_end_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                        </div>
                                        {toggle.invoice_end_date && <Calendar 
                                            value={(selected.invoice_end_date)} 
                                            onChange={(val) => handleDate(val, 'invoice_end_date')} 
                                            minDate={moment(selected.invoice_start_date).toDate()} 
                                            placeholder="Date to" />}

                                    </div>
                                </div>
                                <div className={`tab-pane ${selectedType === 'order_date' ? 'show active' : 'hidden'}  fade px-3`} id="pilltype" role="tabpanel" aria-labelledby="pills-type">
                                    <div ref={dateRef1} className="relative">
                                        <div className="flex sm:flex-row flex-col items-center mt-1 -mx-1">
                                            <div 
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('order_start_date')}
                                            >
                                                <label></label>
                                                <img 
                                                    src="/images/Iconawesome-calendar-alt.svg" 
                                                    alt="icon" 
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('order_start_date')}
                                                />
                                                <input 
                                                    datepicker 
                                                    datepicker-autohide 
                                                    type="text" 
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] sm:text-xs9 text-sm29 font-semibold text-[#090406] px-2.5 placeholder:text-xs9 placeholder:font-normal placeholder:text-[#808285]"  
                                                    placeholder="From date"
                                                    value={selected.order_start_date === '' ? '' : moment(selected.order_start_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.order_start_date && <Calendar 
                                                value={moment(selected.order_start_date).format('YYYY/MM/DD').order_start_date} 
                                                onChange={(val) => handleDate(val, 'order_start_date')} 
                                                placeholder="Date from" 
                                            />}
                                            <div 
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('order_end_date')}
                                            >
                                                <label></label>
                                                <img 
                                                    src="/images/Iconawesome-calendar-alt.svg" 
                                                    alt="icon" 
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('order_end_date')}
                                                />
                                                <input 
                                                    datepicker 
                                                    datepicker-autohide 
                                                    type="text" 
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] sm:text-xs9 text-sm29 font-semibold text-[#090406] px-2.5 placeholder:text-xs9 placeholder:font-normal placeholder:text-[#808285]"  
                                                    placeholder="To date"
                                                    value={selected.order_end_date === '' ? '' : moment(selected.order_end_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />                    
                                            </div>
                                            {toggle.order_end_date && <Calendar 
                                                value={(selected.order_end_date)} 
                                                onChange={(val) => handleDate(val, 'order_end_date')} 
                                                minDate={moment(selected.order_start_date).toDate()} 
                                                placeholder="Date to" />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>   
                        </div>
                        <div className="flex w-full">
                            <div className="pt-3 flex justify-end w-[30%] mr-5">
                                <button 
                                    type="button" 
                                    className="w-full sm:h-10 h-9 border-2 border-[#555259]  bg-[#FFFFFF] rounded-lg text-sm font-semibold filter1 text-[#555259]" 
                                    data-bs-dismiss="modal" 
                                    aria-label="Close"
                                    onClick={() => handleClear()}
                                >
                                    Clear Filter
                                </button>
                            </div>
                            <div className="pt-3 flex justify-end w-[70%]">
                                <button 
                                    type="button" 
                                    className="w-full sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold apply text-[#FFFFFF]" 
                                    data-bs-dismiss="modal" 
                                    aria-label="Close"
                                    onClick={() => generateUrl()}
                                >
                                    Apply Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FilterModal
